import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import Filters from '../../../../components/GlobalFilters';
import ContentContainter from '../../../../templates/Content/ContentContainer';

import NoPermission from '../../../../components/NoPermission';
import checkPermission from '../../../../utils/checkPermission';

import MainPage from './Pages/Main';

const Main = () => {
  const { t } = useTranslation();
  const [isInitialFiltersReady, setIsInitialFiltersReady] = useState(false);

  if (!checkPermission('dashboard-view')) {
    return <NoPermission />;
  }

  return (
    <ContentContainter title={t('scheduledVisits')}>
      <Filters
        dateByPeriod
        periodType="datetime-local"
        defaultDateRangeDaysBack={7}
        maxDateRangeDays={31}
        allowFutureDateRange
        onInitialFiltersApplied={() => setIsInitialFiltersReady(true)}
      />

      {isInitialFiltersReady && <MainPage />}
    </ContentContainter>
  );
};

export default Main;
